import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isOdulOneriOpexAuthorized } from '../helper/authorizedUsers'

/** Ödül Öneri OPEX ekranları — login + odul_opex */
const OdulOneriOpexRoute = () => {
  const { currentUser } = useSelector((state) => state.auth)

  if (!currentUser) {
    return <Navigate to="/login" />
  }

  if (!isOdulOneriOpexAuthorized(currentUser)) {
    return <Navigate to="/access-denied" />
  }

  return <Outlet />
}

export default OdulOneriOpexRoute
